import React, { useEffect, useState } from "react"
import HowTrackTireDepth from "./HowTrackTireDepth"
import { useTranslation } from "react-i18next"
import TireTreadDepthStatus from "./TireTreadDepthStatus"
import TreadDepthTireDetails from "./TreadDepthTireDetails"
import ReactSVG from "react-svg"
import UnlockMilesInfoLogo from "../../../images/rewards/unlock-miles-info.svg"
import { Button } from "semantic-ui-react"
import { DASHBOARD, TIRES, TIRE_DEPTH_STATUS } from "../../constants/tires"
import { routerPaths } from "../../constants/paths"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { updateActiveVehicle } from "../../actions/user"
import { resetTireData } from "../../actions/tires"
import { handleTireStatusData } from "../../helpers/vehicleHelpers"

const TreadDepthTracker = ({
  isLastTreadDepthRecordVisible = true,
  module,
  vehicle,
  history,
  updateActiveVehicle,
  resetTireData,
  noteHeader
}) => {
  const { t } = useTranslation("treadDepthTracker")

  const [openTreadDepthDialog, setOpenTreadDepthDialog] = useState(false)
  const [vehicleTireStatus, setVehicleTireStatus] = useState([])
  const [buyTires, setBuyTires] = useState(0)
  const [vehicleDepthMeasured, setVehicleDepthMeasured] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleTreadDepthDialog = () => {
    setOpenTreadDepthDialog((prev) => !prev)
  }

  const handleVehicleTireStatus = () => {
    const { tire_tread_fl, tire_tread_fr, tire_tread_rl, tire_tread_rr } = vehicle

    const { tireStatusData, buyNewTiresCount } = handleTireStatusData(
      tire_tread_fl,
      tire_tread_fr,
      tire_tread_rl,
      tire_tread_rr
    )

    setBuyTires(buyNewTiresCount)
    setVehicleDepthMeasured(
      !!tire_tread_fl && !!tire_tread_fr && !!tire_tread_rl && !!tire_tread_rr
    )
    setVehicleTireStatus(tireStatusData)
  }

  useEffect(() => {
    handleVehicleTireStatus()
  }, [vehicle])

  const redirectToTireSize = async () => {
    setIsLoading(true)
    try {
      await updateActiveVehicle(vehicle.id)
      await resetTireData()
      history.push(routerPaths.topTires)
    } catch (error) {
      console.log(`${t("errorInredirectToTireSize")} ${error}`)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="tread_depth_tracker">
      <div className="tread_depth__header">
        <p className="tread_depth__header">{t("treadDepthTrackerLabel")}</p>
        <ReactSVG
          onClick={handleTreadDepthDialog}
          src={UnlockMilesInfoLogo}
          className="tread_depth__info"
        />
      </div>
      {(!vehicleDepthMeasured || (module === DASHBOARD && buyTires)) && (
        <div className="no_tire_for_track">
          <ReactSVG src={UnlockMilesInfoLogo} className="info_logo" />
          <div>
            <p className="want_to__track">{noteHeader || t("wantToTrackTireDepth")}</p>
            {module !== DASHBOARD && <p className="from_next__apt">{t("atYourNextAppointment")}</p>}
          </div>
        </div>
      )}
      {module !== DASHBOARD && <TireTreadDepthStatus tireStatus={vehicleTireStatus} />}
      {module !== DASHBOARD && isLastTreadDepthRecordVisible && (
        <TreadDepthTireDetails vehicle={vehicle} />
      )}
      <HowTrackTireDepth
        openDialog={openTreadDepthDialog}
        handleTreadDepthDialog={handleTreadDepthDialog}
      />
      {module === DASHBOARD && (
        <div className="treadepth__dashboard">
          <TireTreadDepthStatus className="dashboard_container" tireStatus={vehicleTireStatus} />
          {!!buyTires && module !== TIRES && (
            <Button
              onClick={redirectToTireSize}
              disabled={isLoading}
              className="buy_tires dashboard"
            >
              {t("buyNewTires")} ({buyTires})
            </Button>
          )}
        </div>
      )}
      {!!buyTires && module !== DASHBOARD && module !== TIRES && (
        <Button onClick={redirectToTireSize} className="buy_tires">
          {t("buyNewTires")} ({buyTires})
        </Button>
      )}
    </div>
  )
}

export default connect(null, { updateActiveVehicle, resetTireData })(withRouter(TreadDepthTracker))
